import cloudModule from './../cloud.module';
import template from './url-verification.component.html';
import style from './url-verification.component.scss';

export default cloudModule.component('urlVerification', {
    template: template,
    style: style,
    controller: urlVerificationComponent
});

function urlVerificationComponent($window, $state, $stateParams) {
    const vm = this;

    if (
        $stateParams.instanceGuid == undefined ||
        $stateParams.origin == undefined
    ) {
        $state.go('app');
        return;
    }

    vm.originUrl = $stateParams.origin;
    vm.isUnsecureOrigin = vm.originUrl.indexOf('http://') === 0;
    vm.notSecureMessage =
        '<span class="tooltipmessage">The connection to <span class="focus">' +
        vm.originUrl +
        '</span> is not secure. Any sensitive information entered could be stolen by attackers.</span>';

    vm.cancel = function() {
        $window.close();
    };

    vm.confirm = function() {
        $state.go('registration', {
            instanceGuid: $stateParams.instanceGuid,
            origin: $stateParams.origin
        });
    };
}



// WEBPACK FOOTER //
// ./modules/cloud/url-verification/url-verification.component.js